exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".search-bar-subtitle{font-style:italic;font-size:.875em;color:var(--text-light);margin-top:.5em;font-weight:lighter;height:1.35em}", ""]);

// exports
